import {VatTuModule} from '@entities/vat-tu/vat-tu.module';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@app/shared';
import {RouterModule, Routes} from '@angular/router';

import {GiongComponent, GiongPopupRoute, giongRoute} from './';
import {
  GiongDialogComponent,
  GiongPopupComponent,
} from '@entities/giong/giong-dialog/giong-dialog.component';
import {
  GiongMgmtDeleteDialogComponent,
  GiongMgmtDeletePopupComponent,
} from '@entities/giong/giong-delete-dialog/giong-delete-dialog.component';
import {
  GiongImportComponent,
  GiongImportPopupComponent,
} from '@entities/giong/giong-import/giong-import.component';
import {GiongDetailComponent} from '@entities/giong/giong-detail/giong-detail.component';
import {
  GiongStorageDialogComponent,
  GiongStoragePopupComponent,
} from '@entities/giong/giong-storage-dialog/giong-storage-dialog.component';
import {
  GiongDeleteHistoryDialogComponent,
  GiongDeleteHistoryPopupComponent,
} from '@entities/giong/giong-delete-history-dialog/giong-delete-history-dialog.component';

const ENTITY_STATES = [...giongRoute, ...GiongPopupRoute];

@NgModule({
  declarations: [
    GiongComponent,
    GiongDialogComponent,
    GiongPopupComponent,
    GiongMgmtDeleteDialogComponent,
    GiongMgmtDeletePopupComponent,
    GiongImportComponent,
    GiongImportPopupComponent,
    GiongDetailComponent,
    GiongStorageDialogComponent,
    GiongStoragePopupComponent,
    GiongDeleteHistoryDialogComponent,
    GiongDeleteHistoryPopupComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(ENTITY_STATES as Routes),
    VatTuModule,
  ],
  entryComponents: [
    GiongDialogComponent,
    GiongPopupComponent,
    GiongMgmtDeleteDialogComponent,
    GiongMgmtDeletePopupComponent,
    GiongImportComponent,
    GiongImportPopupComponent,
    GiongStoragePopupComponent,
    GiongStorageDialogComponent,
    GiongDeleteHistoryPopupComponent,
    GiongDeleteHistoryDialogComponent,
  ],
})
export class GiongModule {}
